/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Group name for events log filter:
 *   * TAG : The tag field
 *   * DESCRIPTION : The tag description field
 *   * DATE : The date field
 *   * VALUE : The value field
 *   * GROUP : The tag group field
 */
export enum EventsLogFieldGroupType {
  TAG = 'TAG',
  DESCRIPTION = 'DESCRIPTION',
  DATE = 'DATE',
  VALUE = 'VALUE',
  GROUP = 'GROUP'
}
